import { useNavigation } from "@react-navigation/native";
import ContentMenu from "../../../components/navigation/ContentMenu/ContentMenu";
import { useGetGeneratedContentQuery } from "../../../graphql/generated/graphql";
import { useEffect } from "react";
import { Text, View } from "react-native";

function ContentMenuContainer({ courseName }) {
  const navigation = useNavigation();

  const {
    data,
    loading,
    error,
    refetch: refetchContent,
  } = useGetGeneratedContentQuery({ fetchPolicy: "network-only" });

  useEffect(() => {
    refetchContent();
    if (error) {
      console.error("Error fetching data: ", error);
    }
    if (data) {
      console.log("Generated Content Data: ", data.getGeneratedContent);
    } else {
      console.log("Data is undefined");
    }
  }, [data, error, refetchContent]);

  if (loading)
    return (
      <View>
        <Text>Loading...</Text>
      </View>
    );

  const courses = data?.getGeneratedContent || [];
  const selectedCourse = courses.filter((c) => c.name === courseName);

  const handleAssignmentPress = (assignmentName, moduleName, courseName) => {
    const selectedCourse = courses.find((c) => c.name === courseName);
    if (!selectedCourse) {
      console.error(`Course with name "${courseName}" not found.`);
      return;
    }

    const module = selectedCourse.modules.find((mod) => mod.module_name === moduleName);
    if (!module) {
      console.error(`Module with name "${moduleName}" not found.`);
      return;
    }

    const assignment = module.assignments.find((assign) => assign.assignment_name === assignmentName);
    if (!assignment) {
      console.error(`Assignment with name "${assignmentName}" not found in module "${moduleName}".`);
      return;
    }

    navigation.navigate("Modules", {
      id: selectedCourse.id,
      courseName: courseName,
      moduleIndex: selectedCourse.modules.indexOf(module),
      assignmentIndex: module.assignments.indexOf(assignment),
      assignment: {
        name: assignment.assignment_name,
        html: assignment.html,
      },
    });
  };

  const handleAddPress = () => {
    console.log("add pressed");
  };

  return (
    <>
      {courses.length > 0 ? (
        <ContentMenu
          data={selectedCourse[0]}
          topicName={selectedCourse[0]?.name}
          onAddPress={handleAddPress}
          onAssignmentPress={handleAssignmentPress}
        />
      ) : (
        <View>
          <Text>No courses available</Text>
        </View>
      )}
    </>
  );
}

export default ContentMenuContainer;
